import React, { useState } from 'react';

const Contact: React.FC = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    company: '',
    position: '',
    description: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formDataToSubmit = new URLSearchParams();
      Object.entries(formData).forEach(([key, value]) => {
        formDataToSubmit.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d3mb5uv68806cmb3mu10', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formDataToSubmit
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          name: '',
          phone: '',
          email: '',
          company: '',
          position: '',
          description: ''
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="sticky top-0 z-50 flex items-center justify-center gap-2 md:h-20 bg-[#071C74] px-4 py-4 font-medium md:flex-none md:justify-start md:p-2 md:px-3">
        <div className="sticky top-0 flex h-7 items-center justify-between md:h-20 w-full max-w-7xl mx-auto">
          <div className="adi-header-left">
            <a href="/">
              <img 
                alt="ADI Logo" 
                width={125} 
                height={56} 
                src="https://static.readdy.ai/image/4d7c1148f372075ad366b96364633fcd/3900b388860a5efa532a02080a385ec7.png" 
                className="h-14 w-auto"
              />
            </a>
          </div>
          
          <div className="hidden md:flex items-center space-x-4 text-white">
            <div className="relative">
              <div className="flex bg-white/10 backdrop-blur-sm rounded-full p-1">
                <button 
                  className="px-4 py-2 text-white bg-white/20 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap"
                >
                  简体中文
                </button>
                <a 
                  href="/en/contact-us"
                  className="px-4 py-2 text-white/70 hover:text-white hover:bg-white/10 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap"
                >
                  English
                </a>
              </div>
            </div>
            <a 
              href="/flanexus"
              className="px-4 py-2 text-white hover:text-blue-200 transition-colors whitespace-nowrap"
            >
              炎禾智联
            </a>
            
            <a 
              href="/zh/news"
              className="px-4 py-2 text-white hover:text-blue-200 transition-colors"
            >
              资讯
            </a>
            
            <a 
              href="/zh/contact-us"
              className="px-4 py-2 border border-white rounded-full bg-white text-[#071C74] transition-colors"
            >
              联系我们
            </a>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex min-h-screen">
        <div className="w-full py-4 md:px-9 md:py-9">
          <div className="max-w-7xl mx-auto flex w-full flex-col-reverse p-5 md:flex md:flex-row md:flex-wrap md:p-0">
            
            {/* Left Content */}
            <div className="md:w-[45%]">
              <p className="hidden leading-6 text-black/85 md:block">
                亚数智库(ADI)专注于为亚太地区企业提供全流程数字化服务。从前期咨询到运营达标,我们助力您实现项目目标,确保顺利落地。
              </p>
              <p className="hidden pt-[8px] leading-6 text-black/85 md:block">
                如果您在以上任何方面有需求或疑问,请填写以下信息,我们的专家团队将在两个工作日内与您联系,进行免费在线交流,答疑解惑,助力您的数字化转型之旅。
              </p>
              
              <div className="hidden pb-[60px] pt-8 md:block">
                <img 
                  alt="contact us" 
                  width={1064} 
                  height={704} 
                  src="https://static.readdy.ai/image/4d7c1148f372075ad366b96364633fcd/50fe40e260cbf55354a611878bcdd060.png" 
                  className="w-full"
                />
              </div>
              
              <hr className="hidden md:block border-gray-200" />
              
              <div className="block pb-[60px] md:hidden">
                <img 
                  alt="contact us" 
                  width={1064} 
                  height={704} 
                  src="https://static.readdy.ai/image/4d7c1148f372075ad366b96364633fcd/50fe40e260cbf55354a611878bcdd060.png" 
                  className="w-full"
                />
              </div>
              
              <hr className="block md:hidden border-gray-200" />
              
              <div className="mt-8">
                <div className="mb-4 flex justify-between">
                  <div className="w-[70%] md:w-[58%]">
                    <h4 className="text-[18px] font-bold text-black/85 md:text-[20px] leading-7 mb-2">
                      免费咨询
                    </h4>
                    <p className="text-[12px] leading-4 text-black/65 md:text-[14px] md:leading-5">
                      如您有任何疑问，请扫描企业官方公众号进行咨询。
                    </p>
                  </div>
                  <div className="flex w-[72px] md:w-[80px] items-end">
                    <img 
                      alt="免费咨询" 
                      width={80} 
                      height={80} 
                      src="https://static.readdy.ai/image/4d7c1148f372075ad366b96364633fcd/798e5ca3f4e230ffb5a56d977a1ca61a.jpeg" 
                      className="hidden md:block"
                    />
                    <img 
                      alt="免费咨询" 
                      width={72} 
                      height={72} 
                      src="https://static.readdy.ai/image/4d7c1148f372075ad366b96364633fcd/798e5ca3f4e230ffb5a56d977a1ca61a.jpeg" 
                      className="block md:hidden"
                    />
                  </div>
                </div>
                
                <div className="mb-4 flex justify-between">
                  <div className="w-[70%] md:w-[58%]">
                    <h4 className="text-[18px] font-bold text-black/85 md:text-[20px] leading-7 mb-2">
                      加入ADI
                    </h4>
                    <p className="text-[12px] leading-4 text-black/65 md:text-[14px] md:leading-5">
                      如您在数字化领域有相关实操与项目经验，欢迎加入我们的顾问网络，申请参与活动论坛、报告撰写以及企业项目等。
                    </p>
                  </div>
                  <div className="flex w-[72px] md:w-[80px] items-end">
                    <img 
                      alt="加入ADI" 
                      width={80} 
                      height={80} 
                      src="https://static.readdy.ai/image/4d7c1148f372075ad366b96364633fcd/798e5ca3f4e230ffb5a56d977a1ca61a.jpeg" 
                      className="hidden md:block"
                    />
                    <img 
                      alt="加入ADI" 
                      width={72} 
                      height={72} 
                      src="https://static.readdy.ai/image/4d7c1148f372075ad366b96364633fcd/798e5ca3f4e230ffb5a56d977a1ca61a.jpeg" 
                      className="block md:hidden"
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Right Content - Form */}
            <div className="w-full grow md:w-[55%] md:pl-[10%]">
              <p className="block leading-6 text-black/85 md:hidden text-[14px] mb-2">
                亚数智库(ADI)专注于为亚太地区企业提供全流程数字化服务。从前期咨询到运营达标,我们助力您实现项目目标,确保顺利落地。
              </p>
              <p className="block pt-[8px] leading-6 text-black/85 md:hidden text-[14px] mb-6">
                如果您在以上任何方面有需求或疑问,请填写以下信息,我们的专家团队将在两个工作日内与您联系,进行免费在线交流,答疑解惑,助力您的数字化转型之旅。
              </p>
              
              <div className="mt-6 h-full rounded-lg bg-[#F5F5F5] pb-10 md:mt-0 md:pb-8 px-4 md:px-16 pt-8">
                <form 
                  onSubmit={handleSubmit}
                  data-readdy-form
                  className="space-y-6"
                >
                  <div>
                    <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">
                      姓名 *
                    </label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      placeholder="姓名"
                      required
                      className="w-full px-3 py-3 border-b border-gray-300 bg-transparent focus:border-blue-5
0 focus:outline-none text-sm"
                    />
                  </div>

                  <div>
                    <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-2">
                      联系电话 *
                    </label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleInputChange}
                      placeholder="联系电话"
                      required
                      className="w-full px-3 py-3 border-b border-gray-300 bg-transparent focus:border-blue-500 focus:outline-
none text-sm"
                    />
                  </div>

                  <div>
                    <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                      企业邮箱 *
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      placeholder="企业邮箱"
                      required
                      className="w-full px-3 py-3 border-b border-gray-300 bg-transparent focus:border-blue-500 focus:outline-
none text-sm"
                    />
                  </div>

                  <div>
                    <label htmlFor="company" className="block text-sm font-medium text-gray-700 mb-2">
                      公司名称 *
                    </label>
                    <input
                      type="text"
                      id="company"
                      name="company"
                      value={formData.company}
                      onChange={handleInputChange}
                      placeholder="公司名称"
                      required
                      className="w-full px-3 py-3 border-b border-gray-300 bg-transparent focus:border-blue-500 focus:outline-
none text-sm"
                    />
                  </div>

                  <div>
                    <label htmlFor="position" className="block text-sm font-medium text-gray-700 mb-2">
                      职位名称 *
                    </label>
                    <input
                      type="text"
                      id="position"
                      name="position"
                      value={formData.position}
                      onChange={handleInputChange}
                      placeholder="职位名称"
                      required
                      className="w-full px-3 py-3 border-b border-gray-300 bg-transparent focus:border-blue-500 focus:outline-
none text-sm"
                    />
                  </div>

                  <div>
                    <label htmlFor="description" className="block text-sm font-medium text-gray-700 mb-2">
                      需求描述 *
                    </label>
                    <textarea
                      id="description"
                      name="description"
                      value={formData.description}
                      onChange={handleInputChange}
                      placeholder="请输入您想对我们说的话"
                      required
                      rows={4}
                      maxLength={500}
                      className="w-full px-3 py-3 border border-gray-300 rounded-md bg-white focus:border-blue-500 focus:outline-none text-sm resize-none"
                    />
                    <div className="text-xs text-gray-500 mt-1">
                      {formData.description.length}/500
                    </div>
                  </div>

                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="w-full bg-blue-600 text-white py-4 px-6 rounded-full hover:bg-blue-700 disabled:bg-blue-400 transition-colors font-medium text-lg whitespace-nowrap"
                  >
                    {isSubmitting ? '提交中...' : '提交需求'}
                  </button>

                  {submitStatus === 'success' && (
                    <div className="text-green-600 text-center text-sm">
                      提交成功！我们将在两个工作日内与您联系。
                    </div>
                  )}

                  {submitStatus === 'error' && (
                    <div className="text-red-600 text-center text-sm">
                      提交失败，请稍后重试。
                    </div>
                  )}
                </form>
              </div>
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="flex h-28 items-center justify-center bg-[#F7F7F7]">
        <span className="text-lg font-semibold text-black/85">战略合作伙伴: </span>
        <a 
          href="https://www.flanexus.com/" 
          target="_blank" 
          rel="noopener noreferrer"
          className="ml-1 text-lg font-semibold underline decoration-[#2D66F4] text-[#2D66F4] hover:text-blue-700"
        >
          炎禾智联
        </a>
        <div className="ml-8">
          <a 
            href="https://readdy.ai/?origin=logo" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-sm text-gray-500 hover:text-gray-700"
          >
            Powerd by AI
          </a>
        </div>
      </footer>
    </div>
  );
};

export default Contact;
